import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getProductInformationSettings } from 'apis/restaurant-api/merchant-admin/menu2/api';
import { ProductHierarchyLevel } from 'apis/restaurant-api/merchant-admin/menu2/types';

export const useProductInformationSettings = (menuId: string) => {
  const {
    data: { product_hierarchy_levels: productHierarchyLevels } = {
      nutrition_values: [],
      product_hierarchy_levels: [],
    },
    isFetching,
    error: errorProductInformationSettings,
  } = useQuery([`product-information-settings/${menuId}`], () => getProductInformationSettings(menuId), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  // build hashmap of product hierarchy levels
  const productHierarchyLevelsMap = useMemo(() => {
    const map = new Map<string, ProductHierarchyLevel>();
    if (isFetching) {
      return map;
    }
    productHierarchyLevels.forEach((productHierarchyLevel: ProductHierarchyLevel) => {
      map.set(productHierarchyLevel.id, productHierarchyLevel);
    });
    return map;
  }, [productHierarchyLevels, isFetching]);

  return {
    productHierarchyLevelsMap,
    isFetching,
    errorProductInformationSettings,
  };
};
